import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home'
import login from './views/login'
import types from './store/globaltypes'

Vue.use(Router)

export function registerAuthRouteGuard (router, store) {
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !store.getters[types.user.getters.currentUser]) {
      next({
        path: '/login',
        query: { redirect: to.name }
      })
    } else {
      next()
    }
  })
}

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [{
    path: '/',
    name: 'home',
    hide: true,
    component: home,
    meta: {
      displayName: ''
    }
  }, {
    path: '/calendar',
    name: 'calendar',
    hide: false,
    components: {
      default: () => import(/* webpackChunkName: "calendarview" */ './views/calendarview'),
      toolbar: () => import(/* webpackChunkName: "calendarview" */ './components/calendar')
    },
    meta: {
      displayName: 'Kalender',
      titleKey: 'calendar.tasks',
      icon: 'fa-calendar-alt',
      requiresAuth: true
    }
  }, {
    path: '/crops',
    name: 'crops',
    components: {
      default: () => import(/* webpackChunkName: "crops" */ './views/crops'),
      toolbar: () => import(/* webpackChunkName: "crops" */ './components/cropfilters')
    },
    meta: {
      displayName: 'gewassen',
      titleKey: 'crops.cropinfo',
      requiresAuth: true,
      icon: 'fa-seedling'
    }
  }, {
    path: '/crops/:cropname',
    name: 'cropinfo',
    hide: true,
    component: () => import(/* webpackChunkName: "single-crop" */ './views/single-crop'),
    meta: {
      displayName: 'gewas info',
      icon: 'fa-seedling',
      requiresAuth: true,
      parent: 'crops'
    }
  }, {
    path: '/wishlist',
    name: 'wishlist',
    hide: false,
    component: () => import(/* webpackChunkName: "wishlist" */ './views/shoppingcart'),
    meta: {
      displayName: 'verlanglijst',
      titleKey: 'wishlist.wishlist',
      icon: 'fa-heart',
      requiresAuth: true,
      showCounter: true
    }
  }, {
    path: '/settings',
    name: 'settings',
    hide: true,
    component: () => import(/* webpackChunkName: "settings" */ './views/settings'),
    meta: {
      titleKey: 'settings.settings',
      displayName: 'instellingen',
      requiresAuth: true
    }
  }, {
    path: '/wizard',
    name: 'wizard',
    hide: false,
    component: () => import(/* webpackChunkName: "lizard" */ './views/wizard'),
    meta: {
      displayName: 'planner',
      titleKey: 'planner.planner',
      icon: 'fas fa-search',
      requiresAuth: true
    }
  }, {
    path: '/login',
    name: 'login',
    hide: true,
    component: login,
    meta: {
      titleKey: 'login.login'
    }
  }]
})
